import { render, staticRenderFns } from "./publishEditor.vue?vue&type=template&id=dd542d92&scoped=true"
import script from "./publishEditor.vue?vue&type=script&lang=js"
export * from "./publishEditor.vue?vue&type=script&lang=js"
import style0 from "./publishEditor.vue?vue&type=style&index=0&id=dd542d92&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd542d92",
  null
  
)

export default component.exports